import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropperModalComponent } from './image-cropper-modal.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        ImageCropperModule
    ],
    declarations: [
        ImageCropperModalComponent
    ],
    exports: [
        ImageCropperModalComponent,
        ImageCropperModule
    ]
})
export class ImageCropperModalModule {
}
